import React from 'react'
import { array } from 'prop-types'
import classNames from 'classnames'
import styles from './IframeCarousel.module.scss'
import Carousel from '@/component/Primitive/Carousel'

const IframeCarousel = ({ items }) => (
  <Carousel
    paginationClassName={styles.CarouselPagination}
    options={{
      nextDisabledOffsetFromEnd: 0
    }}
    className={classNames(styles.IframeCarousel)}
  >
    {items?.map((item) => (
      <div className={styles.IframeCarouselContainer} key={item.iframeSrc}>
        <iframe
          title={items.title}
          src={item.iframeSrc}
          className={styles.IframeCarousel}
        />
      </div>
    ))}
  </Carousel>
)

IframeCarousel.propTypes = {
  items: array
}

export default IframeCarousel
